import { createSlice } from "@reduxjs/toolkit";

const initialMyClassmatesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const myClassmateSlice = createSlice({
  name: "myClassmates",
  initialState: initialMyClassmatesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getClassmates
    classmatesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanMyClassmatesState
    myClassmatesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});